import axios from 'axios';

// Get all part technician requirements
export const getPartTechnicianRequirements = async (filters = {}) => {
  try {
    const token = localStorage.getItem('token');
    
    // Build query string from filters
    const queryParams = new URLSearchParams();
    if (filters.part_id) queryParams.append('part_id', filters.part_id);
    
    const queryString = queryParams.toString();
    const url = `/api/part-technician-requirements${queryString ? `?${queryString}` : ''}`;
    
    const res = await axios.get(url, {
      headers: {
        'x-auth-token': token
      }
    });
    
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching part technician requirements' };
  }
};

// Get part technician requirement by ID
export const getPartTechnicianRequirementById = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/part-technician-requirements/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });
    
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching part technician requirement' };
  }
};

// Create new part technician requirement
export const createPartTechnicianRequirement = async (requirementData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post('/api/part-technician-requirements', requirementData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error creating part technician requirement' };
  }
};

// Update part technician requirement
export const updatePartTechnicianRequirement = async (id, requirementData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.put(`/api/part-technician-requirements/${id}`, requirementData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error updating part technician requirement' };
  }
};

// Delete part technician requirement
export const deletePartTechnicianRequirement = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.delete(`/api/part-technician-requirements/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });
    
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error deleting part technician requirement' };
  }
};
